import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito tener muchos seguidores?',
  answer: 'No. El sistema está diseñado para funcionar incluso con menos de 1,000 seguidores. Nos enfocamos en vender a la audiencia que ya tienes, no en perseguir números de vanidad.'
}, {
  question: '¿Qué pasa si no soy tecnológico?',
  answer: "Te damos templates 'copia y pega'. Si sabes usar Instagram y enviar un WhatsApp, puedes implementar este sistema."
}, {
  question: '¿Funciona para cualquier nicho?',
  answer: 'Si tienes un conocimiento que ayuda a otros, funciona. Desde fitness y cocina hasta finanzas y diseño.'
}, {
  question: '¿Cómo recibo el acceso?',
  answer: 'Inmediatamente después de tu pago, recibirás un correo con el link de descarga y acceso a todos los bonos.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí. Sin suscripciones ocultas ni cobros mensuales.'
}, {
  question: '¿Qué herramientas adicionales necesito?',
  answer: 'El 90% de lo que enseñamos se puede hacer con herramientas gratuitas o versiones de prueba.'
}, {
  question: '¿Tengo garantía?',
  answer: 'Sí, tienes 7 días de garantía total. O te encanta el sistema, o te devolvemos cada centavo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-[#111111] py-24 px-4" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-19">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-indigo-500 mx-auto rounded-full" data-id="element-20" />
        </motion.div>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#0a0a0a] border border-white/5 rounded-xl overflow-hidden" data-id="element-22">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-23">
                <span className="text-white font-medium text-lg flex items-center gap-3" data-id="element-24">
                  <span data-id="element-25">❓</span> {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-26" />
              </button>

              <AnimatePresence data-id="element-27">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-28">
                    <div className="px-6 pb-6 pt-0 text-gray-300 flex items-start gap-3" data-id="element-29">
                      <span className="mt-1" data-id="element-30">✅</span>
                      <p className="leading-relaxed" data-id="element-31">{faq.answer}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}